import { useCleanFilterForRequest, useSearch } from '@btime/react-contexts'
import React from 'react'

import ServiceOrdersList from './ServiceOrdersList'
import ServiceOrdersLoader from '../_load/ServiceOrdersLoader'

const PageContent = () => {
  const filter = useCleanFilterForRequest()
  const search = useSearch()

  return (
    <ServiceOrdersLoader search={search} filter={filter}>
      <ServiceOrdersList />
    </ServiceOrdersLoader>
  )
}

export default PageContent
